module.exports = __webpack_public_path__ + "img/1562146748.ec7031fd.jpg";